import React from 'react';
import { Link } from 'react-router-dom';
import {
  Box,
  Breadcrumbs,
  Typography,
  Button,
  Link as MuiLink
} from '@mui/material';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import UploadFileIcon from '@mui/icons-material/UploadFile';

/**
 * Toolbar for Document Repository: breadcrumbs + New folder + Upload file.
 * Each breadcrumb segment links to /document-repository (root) or
 * /document-repository/folder/:id. Last segment is current (non-clickable).
 */
export default function Toolbar({
  breadcrumbPath = [],
  onNewFolder,
  onUploadFile
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 1,
        mb: 2,
        pb: 1,
        borderBottom: 1,
        borderColor: 'divider'
      }}
    >
      <Breadcrumbs aria-label="Document repository path">
        {breadcrumbPath.map((segment, index) => {
          const isLast = index === breadcrumbPath.length - 1;
          const href = segment.id
            ? `/document-repository/folder/${segment.id}`
            : '/document-repository';

          if (isLast) {
            return (
              <Typography key={segment.id ?? 'root'} color="text.primary">
                {segment.name}
              </Typography>
            );
          }

          return (
            <MuiLink
              key={segment.id ?? 'root'}
              component={Link}
              to={href}
              underline="hover"
              color="inherit"
              sx={{ cursor: 'pointer' }}
            >
              {segment.name}
            </MuiLink>
          );
        })}
      </Breadcrumbs>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Button
          variant="outlined"
          size="small"
          startIcon={<CreateNewFolderIcon />}
          onClick={onNewFolder}
        >
          New folder
        </Button>
        <Button
          variant="outlined"
          size="small"
          startIcon={<UploadFileIcon />}
          onClick={onUploadFile}
        >
          Upload file
        </Button>
      </Box>
    </Box>
  );
}
